<template>
  <div class="d-flex">
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 3C19.6255 3.00496 15.4315 4.74494 12.3382 7.83822C9.24494 10.9315 7.50496 15.1255 7.5 19.5C7.5 33.6187 22.5 44.2875 23.1375 44.7375C23.393 44.9076 23.6931 44.9984 24 44.9984C24.3069 44.9984 24.607 44.9076 24.8625 44.7375C25.5 44.2875 40.5 33.6187 40.5 19.5C40.495 15.1255 38.7551 10.9315 35.6618 7.83822C32.5685 4.74494 28.3745 3.00496 24 3Z"
        fill="#FECB29"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0005 17.1957C29.5668 16.003 26.8908 15.3926 24.0254 15.377V16.6154C26.9139 16.6319 29.5929 17.2913 32.0005 18.5783V17.1957Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0005 21.7261C29.5668 20.5333 26.8908 19.9229 24.0254 19.9072V21.1458C26.9139 21.1623 29.5929 21.8217 32.0005 23.1087V21.7261Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0005 26.2572C29.5668 25.0644 26.8908 24.454 24.0254 24.4385V25.6769C26.9139 25.6934 29.5929 26.3528 32.0005 27.6398V26.2572Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0248 13.0205V14.2588C21.2085 14.2749 18.4791 14.9049 16 16.2219V14.8394C18.5044 13.6187 21.2326 13.0356 24.0248 13.0205Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0248 17.5518V18.7901C21.2085 18.8062 18.4791 19.4361 16 20.7531V19.3706C18.506 18.1503 21.2305 17.5669 24.0248 17.5518Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0248 22.082V23.3205C21.2081 23.3366 18.4793 23.9663 16 25.2835V23.9009C18.5056 22.6806 21.2311 22.0973 24.0248 22.082Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0248 26.6133V27.8516C21.2079 27.8678 18.4794 28.4975 16 29.8146V28.4322C18.5044 27.2115 21.2328 26.6283 24.0248 26.6133Z"
        fill="#1A1A1A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0005 12.6644C29.5668 11.4717 26.8908 10.8612 24.0254 10.8457V12.084C26.9139 12.1006 29.5929 12.76 32.0005 14.0471V12.6644Z"
        fill="#1A1A1A"
      />
    </svg>
  </div>
</template>
